import { Box, TextField, Button, Typography, Paper, Popover } from "@mui/material";
import { EmojiPicker, useActiveEmoji } from "frimousse";
import React, { useState } from "react";

const EmojiComponentList = ({setInputValue}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const activeEmoji = useActiveEmoji();



    const open = Boolean(anchorEl);
    const id = open ? 'emoji-popover' : undefined;
    return (
        <EmojiPicker.Viewport style={{ flex: 1, overflowY: 'auto', padding: '10px', position: 'static'}}>
            <EmojiPicker.Loading>Loading…</EmojiPicker.Loading>
            <EmojiPicker.Empty>No emoji found.</EmojiPicker.Empty>

            <EmojiPicker.List
                style={{
                    position: 'static',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(8, 1fr)',
                    gap: '5px'
                }} 
                onClick={() =>{
                     setInputValue((prev) => prev + activeEmoji?.emoji)
                }}
            >
                {(emoji) => (
                    <EmojiPicker.Item
                        key={emoji.id}
                        emoji={emoji}
                        style={{
                            cursor: 'pointer',
                            fontSize: '1.5rem',
                            border: 'none',
                            background: 'none',
                            padding: '5px'
                        }}
                    />
                )}
            </EmojiPicker.List>
        </EmojiPicker.Viewport>
    )
}

export default EmojiComponentList;